module.exports = __webpack_public_path__ + "/bundle/asset/admission1-3-081678217ed13c1d019f23903fdd2971.png";